//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { EncryptionService } from '../../general/encryption-service';
import { environment } from 'src/environments/environment';
import { eSimApiPaths } from 'src/app/core/consts';
import { ExceptionsService } from '../../general/exceptions-service';
import { HttpClientService } from '../../general/http-client-service';
import { Injectable } from '@angular/core';
import { Observable, of, switchMap } from 'rxjs';
import { StringResultDTO } from 'src/app/core/interfaces/general/string-result';
import { TariffUsageZoneDTO } from 'src/app/core/models/system/tariff/tariff-usage-zone.dto';

@Injectable({ providedIn: 'root' })

export class TariffsUsageZonesService {
  
  constructor(
    private encryptionService: EncryptionService,
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }
    
  public getById(id: number): Observable<TariffUsageZoneDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>id, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const idEncSS=encResult.result;
                            
                            return this.httpClientService.getById(environment.eSimApi +
                                                                  eSimApiPaths.TariffsUsageZones +
                                                                  "?idEncSS=" + idEncSS, undefined); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
  
  public post(usageTariffZone: TariffUsageZoneDTO): Observable<TariffUsageZoneDTO> {
    try {
      //JSON.stringify(usageTariffZone)
      
      return this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(usageTariffZone))
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const objectEnc=encResult.result;
                            
                            return this.httpClientService.post(environment.eSimApi +
                                                               eSimApiPaths.TariffsUsageZones +
                                                               "?objectEnc=" + objectEnc, {}); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
      
  public put(usageTariffZone: TariffUsageZoneDTO): Observable<TariffUsageZoneDTO> {
    try {
      //JSON.stringify(usageTariffZone)
      
      return this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(usageTariffZone))
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const objectEnc=encResult.result;
                            
                            return this.httpClientService.put(environment.eSimApi +
                                                              eSimApiPaths.TariffsUsageZones +
                                                              "?id=" + usageTariffZone.id +
                                                              "&objectEnc=" + objectEnc, undefined, {}); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
        
  public save(usageTariffZone: TariffUsageZoneDTO): Observable<any> {
    try {
      //JSON.stringify(usageTariffZone);

      if (usageTariffZone.id && <number>usageTariffZone.id>0)
        return this.put(usageTariffZone);
      
      return this.post(usageTariffZone);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
}
